const formatColor = (color) => {
  //delete the last to characters of the color string
  return color.slice(0, -2);
};

export default formatColor;
